import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Flex } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import HeaderNavigation from 'components/HeaderNavigation';
import { FORM_MAX_WIDTH } from 'utils/constants';
import FooterButtons, { FOOTER_HEIGHT } from 'components/FooterButtons';
import FormBody from 'pages/Events/Form/components/FormBody';
import { BODY_SCHEMA, DEFAULT_VALUES, preparePayload } from 'pages/Events/Form/constants';
import ROUTES from 'app/routes';
import { API, APIRoutes } from 'api';
import { setFormErrors } from 'utils/api';
import ComponentPreview from 'components/PreviewWrapper';
import FormWrapper from 'components/FormWrapper';

function EventCreate() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const methods = useForm<EventItem>({
    mode: 'onChange',
    resolver: yupResolver(BODY_SCHEMA),
    defaultValues: DEFAULT_VALUES,
  });

  const { handleSubmit, setError } = methods;

  const { mutate: createEvent, isLoading } = useMutation({
    mutationFn: (data: EventItem) => {
      const payload = preparePayload(data);
      return API.post(APIRoutes.events.index(), payload);
    },
    mutationKey: 'eventsMutation',
    onSuccess: () => {
      toast.success('Impreza została pomyślnie utworzona!');
      navigate(ROUTES.events.base);
      void queryClient.invalidateQueries('events');
    },
    onError: (error) => {
      setFormErrors(setError, error);
      toast.error('Wystąpił problem podczas tworzenia imprezy');
    },
  });

  const onSubmit = handleSubmit((data: EventItem) => createEvent(data));

  return (
    <Box>
      <HeaderNavigation
        baseCrumb={{
          label: 'Imprezy',
          to: ROUTES.events.base,
        }}
        crumbs={[{ to: '', label: 'Dodaj imprezę' }]}
      />
      <FormWrapper {...methods}>
        <Flex gap={4} mb={4} alignItems="flex-start" pb={FOOTER_HEIGHT}>
          <Box w="100%" as="form" id="event-creator" onSubmit={onSubmit} maxW={FORM_MAX_WIDTH}>
            <FormBody isLoading={isLoading} />
          </Box>
          <ComponentPreview kind="event" />
        </Flex>
      </FormWrapper>
      <FooterButtons isLoading={isLoading} isCreate formId="event-creator" onCancel={() => navigate(-2)} />
    </Box>
  );
}

export default EventCreate;
